
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("eQ05w", function(module, exports) {
$parcel$export(module.exports, "default", () => $96c18b414cbe6e5f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $hpUsb = parcelRequire("hpUsb");


var $iq4lN = parcelRequire("iq4lN");

var $gndLe = parcelRequire("gndLe");

var $bWRlG = parcelRequire("bWRlG");


var $eIPRD = parcelRequire("eIPRD");


var $3jBhR = parcelRequire("3jBhR");


var $5Iqpa = parcelRequire("5Iqpa");


var $bYRk6 = parcelRequire("bYRk6");


var $eLQM6 = parcelRequire("eLQM6");


var $9CM6e = parcelRequire("9CM6e");


var $dh538 = parcelRequire("dh538");


var $6fnsQ = parcelRequire("6fnsQ");


var $fJNzZ = parcelRequire("fJNzZ");

var $16GCc = parcelRequire("16GCc");


var $eauJy = parcelRequire("eauJy");

const $96c18b414cbe6e5f$var$datasourceContainerStyleWithMarginTop = /*#__PURE__*/ (0, $9K4OG.css)({
    borderRadius: `${"var(--ds-radius-large, 8px)"}`,
    border: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border, ${(0, $6fnsQ.N40)})`}`,
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    marginBottom: `${"var(--ds-space-150, 0.75rem)"}`,
    transform: 'translateX(-50%)',
    marginTop: `${"var(--ds-space-150, 0.75rem)"}`
});
function $96c18b414cbe6e5f$export$2e2bcd8739ae039(props) {
    const { url: url, data: data, eventHandlers: eventHandlers, smartLinks: smartLinks, isNodeNested: isNodeNested, localId: localId, onSetLinkTarget: onSetLinkTarget } = props;
    const portal = (0, $eauJy.usePortal)(props);
    const { actionOptions: actionOptions } = smartLinks || {};
    const onClick = (0, $3jBhR.getCardClickHandler)(eventHandlers, url);
    const platform = 'web';
    const cardProps = {
        url: url,
        data: data,
        onClick: onClick,
        container: portal,
        isDatasource: !!props.datasource,
        actionOptions: actionOptions,
        CompetitorPrompt: smartLinks?.CompetitorPrompt
    };
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    const onError = ({ err: err })=>{
        if (err) throw err;
    };
    if (props.datasource) {
        const views = props.datasource.views;
        const tableView = views.find((view)=>view.type === 'table');
        const shouldRenderDatasource = tableView && (0, $16GCc.canRenderDatasource)(props.datasource.id);
        if (shouldRenderDatasource) {
            const columns = tableView.properties?.columns;
            const visibleColumnKeys = columns?.map(({ key: key })=>key);
            const columnCustomSizesEntries = columns?.filter((c)=>!!c.width).map(({ key: key, width: width })=>[
                    key,
                    width
                ]);
            const columnCustomSizes = columnCustomSizesEntries?.length ? Object.fromEntries(columnCustomSizesEntries) : undefined;
            const wrappedColumnKeys = columns?.filter((c)=>c.isWrapped).map((c)=>c.key);
            const { datasource: datasource, layout: layout } = props;
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bYRk6.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eIPRD.CardErrorBoundary), {
                unsupportedComponent: (0, $gndLe.default),
                datasourceId: props.datasource.id,
                onSetLinkTarget: onSetLinkTarget,
                ...cardProps
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                    css: $96c18b414cbe6e5f$var$datasourceContainerStyleWithMarginTop,
                    "data-testid": "renderer-datasource-table",
                    "data-local-id": localId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        width: isNodeNested ? '100%' : (0, $fJNzZ.calcBreakoutWidth)(layout, width)
                    }
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eLQM6.default), {
                    datasourceId: datasource.id,
                    parameters: datasource.parameters,
                    visibleColumnKeys: visibleColumnKeys,
                    columnCustomSizes: columnCustomSizes,
                    wrappedColumnKeys: wrappedColumnKeys && wrappedColumnKeys.length > 0 ? wrappedColumnKeys : undefined,
                    url: url
                })))));
        }
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5Iqpa.default), {
            data: data,
            url: url
        });
    }
    let cardComponent;
    if (smartLinks?.ssr && url && // Clean up feature gates when both are fully rolled out.
    // - platform_ssr_smartlink_cards: Controls SSR smart links for confluence (100% rolled out)
    // - jfp-magma-ssr-iv-editor-links: Controls SSR smart links for jira (at time of comment: 50% rolled out)
    // Once both gates are 100% rolled out, remove this condition entirely and make
    // smart link SSR behavior the default.
    // NOTE: This is a temporary solution to allow for the gradual rollout of SSR smart links for jira and keep it
    // fully rolled out for confluence since both gates target different products keep only one gate to control the behavior
    // isnt correct.
    ((0, $dh538.fg)('platform_ssr_smartlink_cards') || (0, $dh538.fg)('jfp-magma-ssr-iv-editor-links'))) cardComponent = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9CM6e.CardSSR), {
        appearance: "block",
        platform: platform,
        ...cardProps,
        url: url,
        onError: onError,
        hideIconLoadingSkeleton: true
    });
    else cardComponent = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hpUsb.Card), {
        appearance: "block",
        platform: platform,
        ...cardProps,
        onError: onError
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bYRk6.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "blockCardView-content-wrap",
        "data-block-card": true,
        "data-card-data": data ? JSON.stringify(data) : undefined,
        "data-card-url": url,
        "data-local-id": localId
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eIPRD.CardErrorBoundary), {
        unsupportedComponent: (0, $iq4lN.default),
        onSetLinkTarget: onSetLinkTarget,
        ...cardProps
    }, cardComponent)));
}

});

parcelRegister("eLQM6", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $b100a9eece33ac5b$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6P9tU")).then((module)=>({
            default: module.DatasourceTableView
        })));
const $b100a9eece33ac5b$var$DatasourceTableViewWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": 'datasource-table-view-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b100a9eece33ac5b$var$LazyDatasourceTableView, props));
};
var $b100a9eece33ac5b$export$2e2bcd8739ae039 = $b100a9eece33ac5b$var$DatasourceTableViewWithWrappers;
module.exports["default"] = $b100a9eece33ac5b$export$2e2bcd8739ae039;

});

parcelRegister("6P9tU", function(module, exports) {

let $4f7edc482192f4a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4f7edc482192f4a1$var$load("1yFlQ"),
    $4f7edc482192f4a1$var$load("grRbg"),
    $4f7edc482192f4a1$var$load("960By"),
    $4f7edc482192f4a1$var$load("6wr18"),
    $4f7edc482192f4a1$var$load("fSNo2"),
    $4f7edc482192f4a1$var$load("5pvpJ"),
    $4f7edc482192f4a1$var$load("8makw"),
    $4f7edc482192f4a1$var$load("e1qbZ"),
    $4f7edc482192f4a1$var$load("eY3St"),
    $4f7edc482192f4a1$var$load("bkd4T"),
    $4f7edc482192f4a1$var$load("ffEVr"),
    $4f7edc482192f4a1$var$load("eXGjr"),
    $4f7edc482192f4a1$var$load("atfX6"),
    $4f7edc482192f4a1$var$load("Wowvf"),
    $4f7edc482192f4a1$var$load("kHOMt"),
    $4f7edc482192f4a1$var$load("hhss7"),
    $4f7edc482192f4a1$var$load("7EorR"),
    $4f7edc482192f4a1$var$load("kUbUu"),
    $4f7edc482192f4a1$var$load("7ixUU")
]).then(()=>parcelRequire('jfuml'));

});


//# sourceMappingURL=blockCard.fcd55867.js.map
